import React from 'react';
import PropTypes from 'prop-types';
import './ProductCartLabel.scss';
import clsx from 'clsx';

const ProductCartLabel = ({ label, className }) => (
  <div className={clsx('ProductCard_label', className)}>
    <span className="ProductCard_labelText">{label}</span>
  </div>
);

ProductCartLabel.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ProductCartLabel;
